import React, { useEffect, useState } from "react";
import { AgGridReact } from "@ag-grid-community/react";
import classNames from "classnames";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import "@ag-grid-community/core/dist/styles/ag-grid.css";
import "@ag-grid-community/core/dist/styles/ag-theme-alpine.css";

import dimensions from "../../../../../util/dimensions-util";
import classes from "./ChecksList.module.css";
import UTIL from '../../../../../util';

const { vw: widthConstant } = dimensions;

let gridAPI;

const colDefsArr = [
  {
    headerName: "Check #",
    field: "checkNumber",
    width: 90,
  },
  {
    headerName: "Emp Name",
    field: "employeeName",
    width: 100,
  },
  {
    headerName: "Deliver To",
    field: "deliverTo",
    width: 100,
  },
  {
    headerName: "Revenue Center",
    field: "revenueCenterName",
    width: 130,
  },
  {
    headerName: "Order Type",
    field: "orderType",
    width: 100,
  },
  {
    headerName: "Pickup Time",
    field: "pickupDate",
    width: 100,
  },
];

const offPremiseCol = [
  {
    headerName: "Vehicle Info",
    field: "vehicleInfo",
    width: 100,
  },
  {
    headerName: "Phone #",
    field: "phoneNumber",
    width: 100,
  },
  {
    headerName: "Order #",
    field: "orderNumber",
    width: 100,
  },
];

const ChecksList = ({
  checksRowData = [],
  setSelectedCheck = () => { },
  selectedItem = {},
  premise,
}) => {
  let ViewWidth = premise ? 65 : 100;
  if (!premise) {
    ViewWidth = (Object.keys(selectedItem).length === 0 && selectedItem.constructor === Object) ? 100 : 65;
  }

  const [colDef, setColDef] = useState(colDefsArr);

  checksRowData &&
    checksRowData.forEach((checksRow) => {
      if (checksRow.id === selectedItem.id) {
        checksRow.rowSelected = true;
      }
      if (checksRow.relatedNotifications && checksRow.relatedNotifications.length > 0) {
        checksRow.highlightRow = true;
      }
    });

  useEffect(() => {
    if (!!gridAPI) {
      gridAPI.ensureIndexVisible(selectedItem.rowIndex, null);
    }
  });

  useEffect(() => {
    if (premise) {
      setColDef([...colDefsArr]);
    } else {
      setColDef([...colDefsArr, ...offPremiseCol]);
    }
  }, [premise]);

  const columnDefs = colDef.map(col => {
    return {
      headerName: col.headerName,
      field: col.field,
      width: col.width * widthConstant,
      resizable: true,
      flex: 1,
      sortable: true,
      cellRendererFramework: ({ data }) => cellRenderer(data, col.field)
    }
  });

  const cellRenderer = (data, key) => {
    const { rowSelected, highlightRow } = data;
    var cellStyle = classNames({
      [classes.column]: true,
      [classes.selectedRow]: rowSelected,
      [classes.highlightRow]: highlightRow,
    });
    return <div className={cellStyle}>{data[key]}</div>;
  };

  const onGridReady = params => {
    gridAPI = params.api;
    params.api.sizeColumnsToFit();
  };

  const onGridSizeChanged = params => {
    params.api.sizeColumnsToFit();
  };

  const onRowClicked = (data, rowIndex) => {
    setSelectedCheck({ ...data, rowIndex });
  };

  const getOverlayContentTemplate = () => {
    return `<span class="ag-overlay-loading-center">Please wait while checks are loading</span>`;
  };

  const getOverlayNoRowsTemplate = () => {
    return `<span class="ag-overlay-loading-center">No checks available</span>`;
  };

  const heightConstant = UTIL.round(window.innerHeight / 900);

  return (
    <div className={classes.checksContainer} style={{ width: `${ViewWidth}%` }}>
      <AgGridReact
        onGridReady={onGridReady}
        onGridSizeChanged={onGridSizeChanged}
        columnDefs={columnDefs}
        rowData={checksRowData}
        rowClass={[classes.gridRowClass]}
        rowHeight={70 * heightConstant}
        headerHeight={80 * heightConstant}
        modules={[ClientSideRowModelModule]}
        onRowClicked={({ data, rowIndex }) => onRowClicked(data, rowIndex)}
        overlayNoRowsTemplate={getOverlayNoRowsTemplate()}
        overlayLoadingTemplate={getOverlayContentTemplate()}
      />
    </div>
  );
};

export default ChecksList;
